import React, { useContext, useEffect } from 'react'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useModal } from '../../../hooks/useModal'
import { EasyPaySuccessIcon } from '../../../assets/icons/EasyPaySuccessIcon'
import { Context } from '../../../Store'
import { Trans, useTranslation } from 'react-i18next'
import { isMobile } from 'react-device-detect'
import { formatToItalianCurrency } from '../../../utils/formatToItalianCurrency'
import { roundToNearestTenCents } from '../../../utils/roundToNearstTenCents'
import { getCurrency, MAXIMUM_APEPAGO_LOAN_AMOUNT } from '../../../constants'

// --- Styles ---
const paperStyles = {
  borderRadius: '20px',
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
  padding: '8px',
  background: '#DCF2F4',
}

const dialogTitleBoxStyles = {
  position: 'relative',
  textAlign: 'center',
}

const closeButtonStyles = {
  position: 'absolute',
  right: 0,
  top: 0,
}

const titleTextStyles = {
  fontSize: isMobile ? '32px' : '48px',
  fontWeight: 700,
  color: '#0C9D9D',
  margin: 0,
}

const headingTextStyles = {
  fontSize: isMobile ? '26px' : '32px',
  lineHeight: isMobile ? '38px' : '46px',
  fontWeight: 700,
  color: '#000',
  width: isMobile ? '100%' : 667,
}

const highlightSpanStyles = {
  backgroundColor: '#F8E88B',
  borderRadius: 5,
  padding: '0 4px',
}

const disclaimerTextStyles = {
  fontSize: isMobile ? '18px' : '24px',
  lineHeight: '100%',
  fontWeight: 400,
  color: '#000',
  marginTop: 8,
  marginBottom: isMobile ? 24 : 12,
  width: isMobile ? '100%' : 509,
}

const footerParaStyles = {
  fontSize: isMobile ? '21px' : '28px',
  fontWeight: 700,
  color: '#000',
  marginTop: 30,
  marginBottom: 0,
  width: isMobile ? '100%' : 523,
}

const footerNoteStyles = {
  fontSize: isMobile ? '16px' : '18px',
  fontWeight: 400,
  color: '#000',
  marginTop: 8,
  marginBottom: 0,
}

const contentBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
}

export const EasyPayPlanAdvertiseDialog = () => {
  const { t } = useTranslation()
  const [{ current_step, property }] = useContext(Context)
  const { value: propertyCurrency } = getCurrency(property.currency)
  const toCurrency = (amount) => formatToItalianCurrency(roundToNearestTenCents(amount))

  const { isOpen, onOpen, onClose } = useModal()

  useEffect(() => {
    if (current_step === 3) onOpen()
  }, [current_step, onOpen])

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ style: paperStyles }}>
      <DialogTitle disableTypography style={{ padding: 0 }}>
        <Box style={dialogTitleBoxStyles}>
          <Typography style={titleTextStyles}>{t('easyPayPlan.advertise.title')}</Typography>
          <IconButton aria-label="close" onClick={onClose} size="small" style={closeButtonStyles}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent style={{ padding: 0 }}>
        <Box style={contentBoxStyles}>
          <Typography style={headingTextStyles}>
            <Trans
              i18nKey="easyPayPlan.advertise.heading"
              components={{
                1: <span style={highlightSpanStyles} />,
              }}
            />
          </Typography>

          <Typography style={disclaimerTextStyles}>
            <Trans i18nKey="easyPayPlan.advertise.disclaimer" components={{ 1: <strong /> }} />
          </Typography>

          <EasyPaySuccessIcon width="260px" height="220px" />

          <Typography style={footerParaStyles}>{t('easyPayPlan.advertise.footerPara')}</Typography>

          <Typography style={footerNoteStyles}>
            <Trans
              i18nKey="easyPayPlan.advertise.footerNote"
              values={{
                currency: propertyCurrency,
                easy_pay_loan_amount: toCurrency(MAXIMUM_APEPAGO_LOAN_AMOUNT),
              }}
            />
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
